export const REPIQ_SOCIAL_MEDIA_STATUS = "REPIQ_SOCIAL_MEDIA_STATUS";
export const SHOW_LOADER = "REPIQ_SOCIAL_MEDIA_STATUS_LOADER";

export interface ISocialMediaStatusState {
    socialMediaStatus: ISocialMediaStatus[];
    isLoading: boolean;
}

export interface ISocialMediaStatus {
    Status: string;
    Username: string;
    NetworkName: string;
    DisplayOrder: number;
    NetworkID: number;
    LastScanDate: string;
    MinimumWordCountFoundForAIProcess: boolean;
    IsPersonalityAnalysing: boolean;
    Agreeableness: number;
    Conscientiousness: number;
    EmotionalRange: number;
    OpennessToExperiences: number;
    Extraversion: number;
}

export interface getSocialMediaAnalysisResult {
    type: "REPIQ_SOCIAL_MEDIA_STATUS";
    socialMediaStatus: ISocialMediaStatus[];
}
export interface ShowAction {
    type: "REPIQ_SOCIAL_MEDIA_STATUS_LOADER";
    isLoading: boolean;
}

export type KnownAction = getSocialMediaAnalysisResult | ShowAction;
